import { render, staticRenderFns } from "./CardPolicyCertificates.vue?vue&type=template&id=9be0e43e"
import script from "./CardPolicyCertificates.vue?vue&type=script&lang=js"
export * from "./CardPolicyCertificates.vue?vue&type=script&lang=js"
import style0 from "./CardPolicyCertificates.vue?vue&type=style&index=0&id=9be0e43e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports